var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFollowIconGrey = function SvgFollowIconGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.847 20.25v-2.007a4.045 4.045 0 00-1.16-2.84 3.932 3.932 0 00-2.799-1.176H5.959a3.927 3.927 0 00-2.799 1.175A4.045 4.045 0 002 18.243v2.008M13.384 8.016a4.06 4.06 0 01-.668 2.231 3.972 3.972 0 01-1.777 1.48 3.907 3.907 0 01-2.287.228 3.942 3.942 0 01-2.027-1.1A4.034 4.034 0 015.54 8.8a4.07 4.07 0 01.225-2.32c.3-.734.807-1.36 1.458-1.802a3.92 3.92 0 015 .5 4.045 4.045 0 011.16 2.839zm6.04 1.404v5.226M22 12.032h-5.152",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFollowIconGrey;